import React from "react";
import Glow from "./Assets/token-glow.png";

import { ReactComponent as SandWatch } from "./Assets/sandWatch.svg";
import { ReactComponent as Pin } from "./Assets/pin.svg";
import { ReactComponent as Asterisk } from "./Assets/asterisk-01.svg";

// import Countdown from "../../../Components/Countdown/Countdown";
import NavigationItems from "./NavigationItems/NavigationItems";

import "./HeroSection.style.scss";

const HeroSection = () => {
  return (
    <section className="maldive-hero-section position-relative">
      <div className="subnavbar align-self-stretch">
        <div className="large-container d-flex justify-content-between py-2 align-items-center text-center">
          <div className="sm-wrapper d-flex flex-wrap align-items-center gap-2 ">
            <span className="zixxar-paradise font-adr font-size-32">
              #ZiXXarParadise
            </span>
            <span className="december-date font-pnr text-white">
              September 2024
            </span>
          </div>

          <NavigationItems />
        </div>
      </div>
      <div className="hero-wrapper">
        <div className="container h-100">
          <div className="hero-content-wrapper d-flex h-100">
            {/* mt-auto when countdown */}
            <div className="hero-content w-100 mt-5 mt-xl-auto d-flex flex-column flex-xxl-row justify-content-center  justify-content-xxl-between align-items-center align-items-xxl-start ">
              <div className="zixxar-paradise-col position-relative">
                <h1 className="font-size-72 font-adr lh-1">#ZIXXarParadise</h1>

                <p className="description font-pnm font-size-24 mb-4">
                  Join us at our private event in the Maldives in September
                  2024, where you will be immersed in an exclusive experience
                  like never before.
                </p>

                <div className="gradient-info d-flex justify-content-center align-items-center position-relative text-white font-pnm font-size-20 text-center">
                  <SandWatch />
                  September 2024 - Dates to be announced soon
                </div>

                <div className="gradient-info mt-4 d-flex justify-content-center align-items-center position-relative text-white font-pnm font-size-20 text-center">
                  <Pin />
                  Republic of Maldives
                </div>

                <div className="tag-container d-flex align-items-center">
                  <div className="asterisk-tag d-flex justify-content-center align-items-center">
                    <Asterisk />
                  </div>

                  <span className="tag-title font-poppins-medium font-size-18 text-white">
                    Private Event
                  </span>
                </div>
              </div>

              {/* <div className="countdown-col d-flex flex-column align-items-center align-items-sm-start justify-content-sm-end mt-4 mt-xxl-auto">
                <h3 className="font-pnm font-size-32 text-white mb-4">
                  Starting in
                </h3>

                <Countdown endDate="2024-07-30T20:00:00" />
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <img src={Glow} alt="glow" className="glow" />
    </section>
  );
};

export default HeroSection;
